import type { SchedulesHostHiddenFilter } from '@efficiently/client-api-schedules';

/**
 * The schedule filters the Supply host hides — not offered to the reader, ignored when they arrive as
 * query parameters, and producing no filter pill.
 *
 * The single list for Supply: `SUPPLY_SCHEDULES_HOST_CONFIG.hiddenFilters` and the Supply navigation
 * places both read it.
 */
export const SUPPLY_SCHEDULES_HIDDEN_FILTERS: readonly SchedulesHostHiddenFilter[] = [
	'installers',
	'procurements',
	'scopes',
	'scopeTypes',
	'scopeStatuses',
	'bidSuppliersInstallers',
];
